import moment from 'moment';

export enum JapaneseDateStringType {
  /** 年月日 + 時分秒 */
  ALL = '1',
  /** 年月日 + 時分 */
  YEAR_MONTH_DATE_HOUR_MIN = '2',
  /** 年月日 */
  YEAR_MONTH_DATE = '3',
  /** 年月 */
  YEAR_MONTH = '4',
  /** 年 */
  YEAR = '5',
}

/**
 * 日付変換共通処理（日付として不正な値である場合は、blankを返します）
 * @param formatString -> ex 'YYYY年MM月DD日 HH:mm:ss' , 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss' ...
 * @param strDateTime
 * @returns DateString formatted by type or blank
 */
const getDateTimeAsStringHelper = (formatString: string, strDateTime?: string | null): string => {
  if (!strDateTime) {
    // 引数が、null , undefined , blankの場合はブランクを返す
    return '';
  }
  const dMoment = moment(strDateTime);
  if (!dMoment.isValid()) {
    // 日付として不正である場合、ブランクを返す
    return '';
  }
  return dMoment.format(formatString);
};

/**
 * 日本語表記日付として、formatする（日付として不正な値である場合は、blankを返します）
 * @param strDateTime -> string to convert
 * @param type -> default DateStringType.ALL
 * @returns DateString formatted by type or blank
 */
export const getJapaneseDateTimeAsString = (
  strDateTime?: string | null,
  type: JapaneseDateStringType = JapaneseDateStringType.ALL
): string => {
  const formatString = 'YYYY年MM月DD日 HH:mm:ss';
  const responseString = getDateTimeAsStringHelper(formatString, strDateTime);
  if (!responseString) {
    return '';
  }
  switch (type) {
    case JapaneseDateStringType.YEAR_MONTH_DATE_HOUR_MIN:
      return responseString.substring(0, 17);
    case JapaneseDateStringType.YEAR_MONTH_DATE:
      return responseString.substring(0, 11);
    case JapaneseDateStringType.YEAR_MONTH:
      return responseString.substring(0, 8);
    case JapaneseDateStringType.YEAR:
      return responseString.substring(0, 5);
    default:
      return responseString;
  }
};
